export default "__VITE_ASSET__SQJ$JWCr__"